import React from "react";
import style from "./style.module.css";
import {
  isCustomDesign,
  subtitleLooksDefault
} from "views/components/Editor/sidebar/tabs/resize/tabs/designs/teamSizeMatch";
import DesignSizeLabel from "views/components/DesignSizeLabel";

export const DesignSizeOption = ({ design, isHighlighted, onClick }) => {
  let label = design.templateSize;
  let subtitle = "";
  if (design.subtitle !== design.templateSize) {
    subtitle = " - " + design.subtitle;
  }
  if (isCustomDesign(design)) {
    // Keep a user-named custom size (e.g. "Wide Banner"); otherwise fall through
    // to the team size name / measurements via DesignSizeLabel.
    subtitle = "";
    label = subtitleLooksDefault(design) ? (
      <DesignSizeLabel design={design} as="span" />
    ) : (
      design.subtitle
    );
  }
  return (
    <div
      className={style.sizeOption}
      data-is-highlighted={isHighlighted}
      onClick={() => onClick(design)}
      data-testid="DesignSizeOption"
    >
      {label}
      {subtitle && <span>{subtitle}</span>}
    </div>
  );
};

DesignSizeOption.displayName = "DesignSizeOption";

export default DesignSizeOption;
